import { gql } from "@apollo/client";
import { useMutation } from "@bb-vendure/admin-ui/react";

const REQUEST_CUSTOMS_CLEARANCE = gql`
  mutation RequestCustomsClearance($orderId: ID!) {
    requestCustomsClearance(orderId: $orderId) {
      id
    }
  }
`;

export default function useRequestCustomsClearance<T>() {
  return useMutation<T>(REQUEST_CUSTOMS_CLEARANCE);
}
